<template>
  <div class="col-12 _col-xl-8 d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Transports par catégorie</h6>
      <div class="card-body position-relative">

        <BarHorizontalComponent
          bar-styles="height: 60px;"
          :data="datas"
          @click="itemOnClick"
        />
        <div class="small text-muted d-flex gap-3 flex-wrap">
          <div v-for="(item, label) in inscritsWithTransportByOption" :key="label">{{ item.label }}: <b>{{ item.count }}</b></div>

          <div class="ms-auto">Total Inscrits: <b>{{ totalInscritsWithTransport }}</b><small v-if="companions.length > 0"> (dont {{ companionOnlyCount }} accompagnants)</small></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as ChartHelper from '@/compositions/chartHelper';
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';

  // Ce widget ne s'intéresse qu'aux inscrits : il n'applique pas le filtre statut
  // (il filtre lui-même sur completionDate) mais applique le filtre organisateurs
  const { travel, participations, companions, filters } = useBoardFilters({ applyStatus: false })

  const companionOnlyCount = computed(() => {
    return companions.value.length ?? 0;
  });

  const inscritsWithTransport = computed(() => {
    return (participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null) ?? []).filter(x=>x.travelInfo?.withPackage == true && x.travelInfo?.withoutTransport != true && x.travelInfo?.specialCase != true) ?? [];
  });

  const companionsWithTransport = computed(() => {
    return filters?.value.hideCompanions ? [] : inscritsWithTransport.value.flatMap(x => x.companions ?? []) ?? [];
  });

  const totalInscritsWithTransport = computed(() => {
    return (inscritsWithTransport.value.length ?? 0) + (companionsWithTransport.value.length ?? 0);
  });

  const inscritsWithTransportByOption = computed(() => {
    const options = travel?.value?.transportations?.flatMap(x => x.options).filter(x => x != null).map(x => x.id) ?? [];
    const uniqueOptions = Array.from(new Set(options));
    const result: Record<string, { label: string, count: number }> = {};
    uniqueOptions.forEach(option => {
      const tempParticipants = inscritsWithTransport.value.filter(x => x.transportation?.optionId === option) ?? [];

      const tempCompanions = filters?.value.hideCompanions ? [] : tempParticipants.flatMap(x => x.companions ?? []) ?? [];
      result[option] = {
        label: travel?.value?.transportations?.flatMap(x => x.options)?.find(x => x?.id === option)?.name ?? `Option ${option}`,
        count: tempParticipants.length + tempCompanions.length
       };
    });
    return result;
  });

  const datas = computed(() => {
    return {
      labels: ["Participants"],
      datasets: inscritsWithTransportByOption.value ? Object.keys(inscritsWithTransportByOption.value).map((optionId, index) => {
        return {
          customData: optionId,
          label: inscritsWithTransportByOption.value[optionId].label,
          data: [inscritsWithTransportByOption.value[optionId].count],
          backgroundColor: [ChartHelper.Colors[index % ChartHelper.Colors.length]],
          borderColor: [ChartHelper.Borders[index % ChartHelper.Borders.length]],
        }
      }) : []
    }
  });

  const itemOnClick = (label: string | undefined, value: number | [number, number] | undefined | null, index: number) => {
    if(filters && datas.value.datasets[index]?.customData) {
      const optionId = parseInt(datas.value.datasets[index].customData);
      filters.value.transportOption = { id: optionId, label: inscritsWithTransportByOption.value[optionId].label };
    }
  };
</script>
